import { BaseButton } from 'components/base-button'
import { searchOutline } from 'ionicons/icons'
import ISearchButtonProps from './search-button-props.interface'
import './search-button.scss'

const SearchButton: React.FC<ISearchButtonProps> = (props) => {
  return (
    <BaseButton
      iconSlot="icon-only"
      icon={searchOutline}
      extraClassName={`edisu-search-button ${props.extraClassName}`}
      color={!!props.color ? props.color : 'secondary'}
      disabled={props.disabled}
      onClickFunction={props.onClickFunction}
      id={props.id}
    ></BaseButton>
  )
}

export default SearchButton
